import React, { cloneElement, isValidElement } from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import ServiceGroup from './ServiceGroup';
import { avatarBg } from '@/functions/formats';
import SectionHead from '@/components/general/SectionHead';
import { ServiceCategory, serviceType } from '@/commonTypes';

export default function HomeServices({
  showHead = true,
  services = [],
}: {
  showHead?: boolean;
  services?: ServiceCategory[];
}) {
  //   const { content, dir } = useLang();
  //   const services = content.services;
  //   const arrow = dir === 'rtl' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
  const head = {
    kicker: 'خدمات کارا',
    title: 'هرچه خودرو لازم دارد، یکجا',
    sub: 'از خلافی و عوارض تا بیمه و معاملهٔ خودرو — همه با چند کلیک.',
  };
  // const services = {
  //   kicker: 'خدمات کارا',
  //   title: 'هرچه خودرو لازم دارد، یکجا',
  //   sub: 'از خلافی و عوارض تا بیمه و معاملهٔ خودرو — همه با چند کلیک.',
  //   groups: [
  //     {
  //       title: 'بدهی‌های خودرو',
  //       icon: <MainIcons.flashIcon />,
  //       bg: avatarBg(0),
  //       items: [
  //         {
  //           t: 'خلافی خودرو',
  //           icon: <MainIcons.coinIcon />,
  //           iconBg: '#FDECE7',
  //           iconColor: 'var(--danger)',
  //           slug: 2,
  //         },
  //         {
  //           t: 'عوارض سالیانه',
  //           icon: <MainIcons.coinIcon />,
  //           iconBg: 'var(--tag-bg)',
  //           iconColor: 'var(--brand-deep)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'طرح ترافیک',
  //           icon: <MainIcons.coinIcon />,
  //           iconBg: 'var(--green-bg)',
  //           iconColor: 'var(--green)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'مالیات نقل و انتقال',
  //           icon: <MainIcons.coinIcon />,
  //           iconBg: 'var(--purple-bg)',
  //           iconColor: 'var(--purple)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'عوارض آزادراهی',
  //           icon: <MainIcons.coinIcon />,
  //           iconBg: 'var(--tag-bg)',
  //           iconColor: 'var(--brand-deep)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'اطلاع‌رسانی پیامکی',
  //           icon: <MainIcons.coinIcon />,
  //           iconBg: 'var(--accent-bg)',
  //           iconColor: 'var(--accent-deep)',
  //           slug: 1,
  //         },
  //       ],
  //     },
  //     {
  //       title: 'خدمات بیمه',
  //       icon: <MainIcons.shieldIcon />,
  //       bg: avatarBg(1),
  //       items: [
  //         {
  //           t: 'بیمهٔ شخص ثالث',
  //           icon: <MainIcons.shieldIcon />,
  //           iconBg: 'var(--tag-bg)',
  //           iconColor: 'var(--brand-deep)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'بیمهٔ بدنهٔ خودرو',
  //           icon: <MainIcons.shieldIcon />,
  //           iconBg: 'var(--green-bg)',
  //           iconColor: 'var(--green)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'بیمهٔ شخص ثالث موتورسیکلت',
  //           icon: <MainIcons.shieldIcon />,
  //           iconBg: '#FDECE7',
  //           iconColor: 'var(--danger)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'بیمهٔ سالیانه',
  //           icon: <MainIcons.shieldIcon />,
  //           iconBg: 'var(--purple-bg)',
  //           iconColor: 'var(--purple)',
  //           slug: 1,
  //         },
  //       ],
  //     },
  //     {
  //       title: 'معاملهٔ خودرو',
  //       icon: <MainIcons.keyIcon />,
  //       bg: avatarBg(2),
  //       items: [
  //         {
  //           t: 'استعلام قیمت خودرو',
  //           icon: <MainIcons.chartIcon />,
  //           iconBg: 'var(--tag-bg)',
  //           iconColor: 'var(--brand-deep)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'انتقال سند',
  //           icon: <MainIcons.chartIcon />,
  //           iconBg: 'var(--accent-bg)',
  //           iconColor: 'var(--accent-deep)',
  //           slug: 1,
  //         },
  //         {
  //           t: 'استعلام اصالت خودرو',
  //           icon: <MainIcons.chartIcon />,
  //           iconBg: 'var(--green-bg)',
  //           iconColor: 'var(--green)',
  //           slug: 1,
  //         },
  //       ],
  //     },
  //   ],
  // };
  const findIcon = (slug: string) => {
    let array = [
      <MainIcons.carIconCategory />,
      <MainIcons.usersIconCategory />,
      <MainIcons.carFinesIcon />,
      <MainIcons.flashIcon />,
    ];
    if (slug == 'خودرو') {
      return array[0];
    }
    if (slug == 'اشخاص') {
      return array[1];
    }
    if (slug == 'بدهی های خودرو') {
      return array[2];
    }
    return array[3];
  };
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {showHead && (
          <SectionHead
            tag={head?.kicker}
            title={head?.title}
            text={head?.sub}
            wrapper={styles.head}
            type="section"
            showMore={false}
          />
        )}

        {services?.map((g, index) => (
          <ServiceGroup
            g={{
              ...g,
              icon: findIcon(g?.slug),
            }}
            key={index}
            i={index}
          />
        ))}
      </div>
    </section>
  );
}
